import { render, staticRenderFns } from "./mr_hlbgx_report.vue?vue&type=template&id=5e5e08bd&scoped=true"
import script from "./mr_hlbgx_report.vue?vue&type=script&lang=js"
export * from "./mr_hlbgx_report.vue?vue&type=script&lang=js"
import style0 from "./mr_hlbgx_report.vue?vue&type=style&index=0&id=5e5e08bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e5e08bd",
  null
  
)

export default component.exports